const vgInitFinder = (root) => {
  if (root.dataset.interactive === 'true') return;
  root.dataset.interactive = 'true';
  const choices = Array.from(root.querySelectorAll('[data-finder-choice]'));
  const results = Array.from(root.querySelectorAll('[data-finder-result]'));
  const reset = root.querySelector('[data-finder-reset]');
  const empty = root.querySelector('[data-finder-empty]');
  if (!choices.length || !results.length) return;
  root.classList.add('is-enhanced');
  results.forEach((result) => {
    result.hidden = true;
    result.style.viewTransitionName = 'vg-finder-result';
    result.setAttribute('tabindex', '-1');
  });
  const update = (key, moveFocus = true) => {
    root.classList.toggle('has-selection', Boolean(key));
    choices.forEach((choice) => choice.setAttribute('aria-pressed', String(choice.dataset.finderChoice === key)));
    let activeResult;
    results.forEach((result) => {
      const isActive = result.dataset.finderResult === key;
      result.hidden = !isActive;
      if (isActive) activeResult = result;
    });
    if (empty) {
      empty.hidden = Boolean(key);
      empty.setAttribute('aria-hidden', String(Boolean(key)));
    }
    if (reset) reset.hidden = !key;
    if (activeResult && moveFocus) activeResult.focus({ preventScroll: true });
    if (key) window.dataLayer?.push({ event: 'charging_finder_select', charging_solution: key });
  };
  choices.forEach((choice) => choice.addEventListener('click', () => {
    const run = () => update(choice.dataset.finderChoice);
    if (document.startViewTransition) document.startViewTransition(run);
    else run();
  }));
  reset?.addEventListener('click', () => {
    root.classList.remove('has-selection');
    choices.forEach((choice) => choice.setAttribute('aria-pressed', 'false'));
    results.forEach((result) => { result.hidden = true; });
    if (empty) {
      empty.hidden = false;
      empty.setAttribute('aria-hidden', 'false');
    }
    reset.hidden = true;
    choices[0]?.focus();
  });
};

document.querySelectorAll('[data-charging-finder]').forEach(vgInitFinder);
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-charging-finder]').forEach(vgInitFinder);
});

const vgInitHeaderSearch = (header) => {
  if (header.dataset.searchInteractive === 'true') return;
  header.dataset.searchInteractive = 'true';
  const toggle = header.querySelector('[data-search-toggle]');
  const panel = header.querySelector('[data-header-search]');
  const close = header.querySelector('[data-search-close]');
  const input = header.querySelector('[data-search-input]');
  if (!toggle || !panel) return;
  const setOpen = (open) => {
    panel.hidden = !open;
    toggle.setAttribute('aria-expanded', String(open));
    if (open) window.requestAnimationFrame(() => input?.focus());
  };
  toggle.addEventListener('click', () => setOpen(panel.hidden));
  close?.addEventListener('click', () => {
    setOpen(false);
    toggle.focus();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !panel.hidden) {
      setOpen(false);
      toggle.focus();
    }
  });
};

document.querySelectorAll('.vg-header').forEach(vgInitHeaderSearch);

const vgInitMegaMenu = (header) => {
  if (header.dataset.megaInteractive === 'true') return;
  header.dataset.megaInteractive = 'true';
  const triggers = Array.from(header.querySelectorAll('[data-mega-trigger]'));
  const panels = Array.from(header.querySelectorAll('[data-mega-panel]'));
  if (!triggers.length || !panels.length) return;
  let activeKey = '';
  let closeTimer;
  const closeAll = (returnFocus = false) => {
    window.clearTimeout(closeTimer);
    const activeTrigger = triggers.find((trigger) => trigger.dataset.megaTrigger === activeKey);
    triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
    panels.forEach((panel) => { panel.hidden = true; });
    activeKey = '';
    if (returnFocus) activeTrigger?.focus();
  };
  const openPanel = (key) => {
    window.clearTimeout(closeTimer);
    triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', String(trigger.dataset.megaTrigger === key)));
    panels.forEach((panel) => { panel.hidden = panel.dataset.megaPanel !== key; });
    activeKey = key;
  };
  triggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      if (activeKey === trigger.dataset.megaTrigger) closeAll();
      else openPanel(trigger.dataset.megaTrigger);
    });
    const item = trigger.closest('.vg-nav__item--mega');
    item?.addEventListener('mouseenter', () => {
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) openPanel(trigger.dataset.megaTrigger);
    });
  });
  header.addEventListener('mouseleave', () => {
    if (!activeKey || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    closeTimer = window.setTimeout(() => closeAll(), 140);
  });
  header.addEventListener('mouseenter', () => window.clearTimeout(closeTimer));
  header.addEventListener('focusout', (event) => {
    if (activeKey && !header.contains(event.relatedTarget)) closeAll();
  });
  document.addEventListener('click', (event) => {
    if (activeKey && !header.contains(event.target)) closeAll();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && activeKey) closeAll(true);
  });
  window.addEventListener('resize', () => {
    if (window.innerWidth <= 980 && activeKey) closeAll();
  });
};

document.querySelectorAll('[data-mega-header]').forEach(vgInitMegaMenu);
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-mega-header]').forEach(vgInitMegaMenu);
});

const vgInitStickyHeader = (header) => {
  if (header.dataset.stickyInteractive === 'true') return;
  header.dataset.stickyInteractive = 'true';
  let frameRequested = false;
  const update = () => {
    header.classList.toggle('is-compact', window.scrollY > 56);
    frameRequested = false;
  };
  const requestUpdate = () => {
    if (frameRequested) return;
    frameRequested = true;
    window.requestAnimationFrame(update);
  };
  update();
  window.addEventListener('scroll', requestUpdate, { passive: true });
};

document.querySelectorAll('[data-sticky-header]').forEach(vgInitStickyHeader);
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-sticky-header]').forEach(vgInitStickyHeader);
});
document.querySelectorAll('[data-collection-sort]').forEach((select) => {
  select.addEventListener('change', () => select.form?.submit());
});

const vgInitRecommendations = (section) => {
  if (section.dataset.loaded === 'true') return;
  section.dataset.loaded = 'true';
  if (!section.dataset.url || !('IntersectionObserver' in window)) return;
  const observer = new IntersectionObserver(([entry]) => {
    if (!entry.isIntersecting) return;
    observer.disconnect();
    fetch(section.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const documentFragment = new DOMParser().parseFromString(text, 'text/html');
        const updated = documentFragment.querySelector('[data-product-recommendations]');
        if (updated?.innerHTML.trim()) {
          section.innerHTML = updated.innerHTML;
          section.hidden = false;
        }
      })
      .catch(() => {});
  }, { rootMargin: '0px 0px 320px 0px' });
  observer.observe(section);
};

document.querySelectorAll('[data-product-recommendations]').forEach(vgInitRecommendations);
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-product-recommendations]').forEach(vgInitRecommendations);
});

const vgInitCompatibilityChecker = (root) => {
  if (root.dataset.interactive === 'true') return;
  root.dataset.interactive = 'true';
  const form = root.querySelector('[data-compatibility-form]');
  const results = root.querySelector('[data-compatibility-results]');
  const resultPanels = Array.from(root.querySelectorAll('[data-compatibility-result]'));
  const error = root.querySelector('[data-compatibility-error]');
  const warning = root.querySelector('[data-connector-warning]');
  const reset = root.querySelector('[data-compatibility-reset]');
  if (!form || !results || !resultPanels.length) return;
  const showResult = (key, connector) => {
    resultPanels.forEach((panel) => { panel.hidden = panel.dataset.compatibilityResult !== key; });
    results.hidden = false;
    if (warning) warning.hidden = connector !== 'unsure';
    results.setAttribute('tabindex', '-1');
    results.focus({ preventScroll: true });
    results.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    window.dataLayer?.push({ event: 'compatibility_check_complete', recommended_solution: key, connector_status: connector });
  };
  form.addEventListener('submit', (event) => {
    event.preventDefault();
    const formData = new FormData(form);
    const setup = formData.get('setup');
    const goal = formData.get('goal');
    const connector = formData.get('connector');
    if (!setup || !goal || !connector) {
      if (error) error.hidden = false;
      form.querySelector('input:invalid')?.focus();
      return;
    }
    if (error) error.hidden = true;
    let recommendation = 'portable';
    if (goal === 'reach' || setup === 'existing') recommendation = 'extension';
    else if (setup === 'hardwired' || goal === 'daily') recommendation = 'wall';
    const update = () => showResult(recommendation, connector);
    if (document.startViewTransition) document.startViewTransition(update);
    else update();
  });
  reset?.addEventListener('click', () => {
    form.reset();
    results.hidden = true;
    if (warning) warning.hidden = true;
    form.querySelector('input')?.focus();
    form.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
};

document.querySelectorAll('[data-compatibility-checker]').forEach(vgInitCompatibilityChecker);
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-compatibility-checker]').forEach(vgInitCompatibilityChecker);
});
